const gerar_arquivo_texto_de_gestores_com_cpf = [
  {
    path: "/gerar-arquivo-texto-de-gestores-com-cpf",
    name: "gerar_arquivo_texto_de_gestores_com_cpf",
    meta: {
      breadCrumb:
        "Censo Escolar - Relatório de Acompanhamento do Censo Escolar",
      allowedPermissions: ["relatorios_gerar_arquivo_gestor"],
    },
    component: () =>
      import(
        "@/views/GerarArquivoTextoDeGestoresComCPF/GerarArquivoTextoDeGestoresComCPF.vue"
      ),
  },
];

export { gerar_arquivo_texto_de_gestores_com_cpf };
